import {cs}                 from "@Common/react/chain-services";
import {consumeContext}     from "@Common/react/context";
import {fragments}          from "@Common/react/fragments";
import {Invoke}             from "@Common/react/invoke";
import {UseState}           from "@Common/react/use-state";
import {ReactGACartEvent}   from "@Common/libs/ga/xd-react-ga";

import {syncCart} from "./sync-cart";

export const AutoCorrectCart = ({next}) => cs(
    consumeContext("apis"),
    consumeContext("cart"),

    ["state", (_, next) => UseState({next})],
    ({state, apis, cart: rootCart}) => fragments(
        next({
            running: !state.value,
            render: ({cart, onError, actions}) => !state.value && (
                Invoke({
                    action: async () => {
                        const cart1 = await syncCart(cart.value, {apis, onError, actions});
                        ReactGACartEvent({eventName:"purchase", cart: cart.value});
                        if (rootCart.value && cart1.cartId === rootCart.value.cartId) {
                            rootCart.onChange(cart1);
                        }
                        cart.onChange(cart1);
                        state.onChange({});
                    },
                })
            ),
        }),
    )
);
